import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Mail, MessageCircle, Clock } from 'lucide-react';
interface ContactSupportModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ContactSupportModal({
  isOpen,
  onClose
}: ContactSupportModalProps) {
  return <AnimatePresence data-id="element-23">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-24">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-25" />

          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative bg-[#FAF7F2] text-[#2D1B4E] rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" data-id="element-26">
            <div className="sticky top-0 bg-[#FAF7F2] border-b border-[#E8D5D5] px-6 py-4 flex items-center justify-between z-10" data-id="element-27">
              <h2 className="text-xl font-bold font-serif" data-id="element-28">Contact Support</h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-[#E8D5D5] transition-colors" aria-label="Close contact support" data-id="element-29">
                <X className="w-5 h-5" data-id="element-30" />
              </button>
            </div>

            <div className="px-6 py-6 space-y-6" data-id="element-31">
              <p className="text-gray-700 leading-relaxed" data-id="element-32">
                For more information and personalized assistance, contact us
                exclusively through our WhatsApp Business or via email.
              </p>

              <div className="space-y-4" data-id="element-33">
                <div className="flex items-start gap-4 p-4 bg-white rounded-xl border border-[#E8D5D5]" data-id="element-34">
                  <div className="w-10 h-10 rounded-full bg-[#25D366]/10 flex items-center justify-center flex-shrink-0" data-id="element-35">
                    <MessageCircle className="w-5 h-5 text-[#25D366]" data-id="element-36" />
                  </div>
                  <div data-id="element-37">
                    <h3 className="font-semibold text-sm mb-1" data-id="element-38">
                      WhatsApp Business
                    </h3>
                    <a href="https://wa.me/15512540741" target="_blank" rel="noopener noreferrer" className="text-[#25D366] hover:underline text-sm" data-id="element-39">
                      +1 (551) 254-0741
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-white rounded-xl border border-[#E8D5D5]" data-id="element-40">
                  <div className="w-10 h-10 rounded-full bg-[#D4A574]/10 flex items-center justify-center flex-shrink-0" data-id="element-41">
                    <Mail className="w-5 h-5 text-[#D4A574]" data-id="element-42" />
                  </div>
                  <div data-id="element-43">
                    <h3 className="font-semibold text-sm mb-1" data-id="element-44">Email</h3>
                    <a href="mailto:info@dreambuk.com" className="text-[#D4A574] hover:underline text-sm" data-id="element-45">
                      info@dreambuk.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-white rounded-xl border border-[#E8D5D5]" data-id="element-46">
                  <div className="w-10 h-10 rounded-full bg-[#D4A574]/10 flex items-center justify-center flex-shrink-0" data-id="element-47">
                    <Clock className="w-5 h-5 text-[#D4A574]" data-id="element-48" />
                  </div>
                  <div data-id="element-49">
                    <h3 className="font-semibold text-sm mb-1" data-id="element-50">
                      Response Time
                    </h3>
                    <p className="text-gray-600 text-sm" data-id="element-51">
                      We typically respond within 24 hours on business days.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}